export default __webpack_public_path__ + "a813034654b4ff0a0bacdf2773a25bcc.svg";